import { graphql } from 'react-relay';

export const searchPageFragment = graphql`
    fragment SearchPage_page on SearchPage 
    @argumentDefinitions(
        searchString: { type: "String", defaultValue: "" }
    )
    {
      breadcrumbs {
        ...Breadcrumb_data
      }
      id
      noResultsText
      path
      resultsTextSingular
      resultsTextPlural
      results( searchString: $searchString ) {
        headline
        snippet
        url
      }
      title
   }
  `;
